module.exports = __webpack_public_path__ + "static/media/galleryImg2.8a42aa87.jpg";